import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { OtherInformationFormalSubForm } from '../subforms/OtherInformationFormal';
import { DocumentsStandardSubForm, Schema as DocumentsStandardSchema } from '../subforms/DocumentsStandard';

export const WeserEnergieProfessionalSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(DocumentsStandardSchema(settings))
);

export const WeserEnergieProfessional = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationFormalSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsStandardSubForm} colors={colors} settings={settings} />
        </>
    );
}